import { App, Plugin as VuePlugin } from 'vue'
import { useMessage } from '@/composables/useMessage'

const {
  createMessage,
  notification,
  createConfirm,
  createSuccessModal,
  createInfoModal,
  createErrorModal,
  createWarningModal,
  destroyAllModal,
} = useMessage()

const Plugin: VuePlugin = {
  install: (app: App) => {
    app.config.globalProperties.$message = createMessage
    app.config.globalProperties.$notification = notification
    app.config.globalProperties.$info = createInfoModal
    app.config.globalProperties.$success = createSuccessModal
    app.config.globalProperties.$error = createErrorModal
    app.config.globalProperties.$warning = createWarningModal
    app.config.globalProperties.$confirm = createConfirm
    app.config.globalProperties.$destroyAll = destroyAllModal
  },
}

export default Plugin
